import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import EngRingImg from "../../../../../Assets/images/collection/engagement-rings.png";
import weddingImg from "../../../../../Assets/images/collection/wedding-bands.png";
import braceletsImg from "../../../../../Assets/images/collection/bracelets.png";
import pendantsImg from "../../../../../Assets/images/collection/pendants.png";
import line from "../../../../../Assets/images/divider-line.png";

// Helper function for image paths
const getImagePath = (filename) => `${ImageUrl}theme/showcase/${filename}`;

const collections = [
  { name: "Engagement Rings", path: "/ringsettings", image:EngRingImg },
  { name: "Wedding Bands", path: "/jewelry/wedding-rings", image: weddingImg },
  { name: "Bracelets", path: "/jewelry/bracelets", image: braceletsImg },
  { name: "Pendants", path: "/jewelry/pendants", image: pendantsImg },
];

const ExploreCollection = () => {
  return (
    <>
    <section className="explore-collection section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Explore Our Collection</h2>
          <p>Explore {Je_welryspelling} Collections by Style and Make a Statement.</p>
        </Heading>

        <Row>
          {collections.map(({ name, path, image }) => (
            <Col key={name} md={3} xs={6}>
              <div className="item text-center">
                <Link to={path} className="img-box" aria-label={`Shop ${name}`}>
                  <Image src={image} alt={name} loading="lazy" />
                </Link>
                <Link to={path}>{name}</Link>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
    <Container fluid className="showcase-container">
      <Row>
        <Col sm={12} md={12} className="p-0">
    <Image src={line} alt="divider line" className="img-fluid w-100"/>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default ExploreCollection;
